export interface FormContextProps{
    values: any
    setValues: (_values: string) => void
    invalidValues: any
    setInvalidValues: (invalidValues: string) => void
    submitAttempted?: boolean
    loading: boolean | undefined
};

export interface FormProps{
    Item?: JSX.Element
    children: JSX.Element | JSX.Element[]
    form?: any
    onSubmit: (values: any, invalidValues: any) => void 
    onValidSubmit: (values: any) => void  
    loading?: boolean,
    className?: string,
    onChangeValues?: (e: any) => void 
 };

 export interface FormItemsProps{
    children: JSX.Element | JSX.Element[], 
    name: string,
    label: string,
    rules: [{ 
        message: string,
        required: boolean, 
        regex: any | undefined, 
        function: any | undefined,
        max: number | undefined, 
        min: number | undefined,
        minDate: any | undefined,
        maxDate: any | undefined,
        email: boolean
    }],
    className: string
 };


export interface CompoundedComponent extends React.ForwardRefExoticComponent<FormProps & React.RefAttributes<HTMLInputElement>> {
    Item: any
    useForm: any
    RC: any
    Footer: any
 }

 export const DEFAULT_VALUES = {
    values: [],
    setValues: () => {},
    invalidValues: [],
    setInvalidValues: () => {}, 
    submitAttempted: false,
    loading: false
}

export interface footerProps  {
    children: JSX.Element | JSX.Element[]
}

export interface headerProps  {
    children: JSX.Element | JSX.Element[]
}

export interface bodyProps  {
    children: JSX.Element | JSX.Element[]
}